import styled from "@emotion/styled";
import { datePickerClasses, timePickerClasses } from "@kaltura/ds-react-components";

export const StyledPickersUnitWrapper = styled("div")(({ theme }) => ({
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        width: "100%",
    },
}));

export const StyledDatePickerWrapper = styled("div")({
    flex: "1 1 0",
});

export const StyledPickersWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        width: "100%",
        justifyContent: "space-between",
        "& > div": {
            maxWidth: "50%",
            flex: "1 1 50%",
        },
        // DatePicker and TimePicker components don't support className prop and can't use styled,
        // so styling them in their styled wrapper
        [`& .${datePickerClasses.input}`]: {
            width: "100%",
        },
        [`& .${timePickerClasses.input}`]: {
            width: "100%",
        },
    },
}));
